export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../assets/images/about/about-banner.jpg'),
        title: '全球IT服务公司',
        description: 'MaesInfo在中国和美国设有分支机构，能够为全球客户提供服务，全天候服务，满足个人需求。',
        component: ''
      }
  ],
  story:{
   title: '我们的故事',
   description: `<span class="img" style="background:url(`+require('../../assets/images/about/about-pic-1.jpg')+`)"></span>
   <p>MaesInfo成立于2005年，已成为专业的领先提供商 IT外包，软件开发，IT解决方案和BPO服务全球客户。MaesInfo在中国和中国的全球发展中心美国与客户建立了长期合作伙伴关系，包括制造业，金融服务业的财富500强企业，医疗保健和零售/批发部门。 凭借其广泛的业绩记录在各个行业工作，MaesInfo拥有成型经验它为各种规模的公司提供解决方案。</p>
   <p>我们的团队包括业务分析师，架构师，流程顾问，接口设计师，软件工程师，DBA和QA / QC工程师，经验丰富熟悉各种编程语言，框架，和行业。</p>`
  },
  otherItem:[
    {
      title: '我们的展望',
      imgUrl: require('../../assets/images/about/about-pic-2.jpg'),
      description: 'MaesInfo寻求成为中国领先的软件外包商高质量的IT外包和具有卓越价值的BPO服务对客户，股东和同事环游世界。',
      component: ''
    },
    {
      title: '我们的任务',
      imgUrl: require('../../assets/images/about/about-pic-3.jpg'),
      description: '通过我们的专业和勤奋，我们努力为我们的客户在全球范围内提供最高质量的IT服务。'
    },
    {
      title: '我们的企业文化',
      imgUrl: require('../../assets/images/about/about-pic-4.jpg'),
      description: '员工和培训：来自美国，加拿大和澳大利亚的母语为英语的员工，以更好地促进客户与开发人员之间的沟通; 语言培训每个工作人员。'
    },
    {
      title: '我们的领导',
      imgUrl: require('../../assets/images/about/about-pic-3.jpg'),
      description: 'MaesInfo的领导团队有着源自全球各大知名品牌的实战经验。我们富有创业精神，鼓励冒险，期待与来自世界各地的同事们分享我们宝贵的技能和经验。'
    },
    {
      title: '我们的优势',
      imgUrl: require('../../assets/images/about/about-pic-5.jpg'),
      description: 'MaesInfo可以为各种规模的企业提供离岸IT外包（ITO），业务流程外包（BPO）和软件开发的规范方法。我们的高质量和低成本运营模式使我们能够为客户节省成本，同时提高业务流程环境中的生产力和可预测性。'
    }
  ]

}
